import { render, staticRenderFns } from "./ListSchool.vue?vue&type=template&id=2f593087&scoped=true"
import script from "./ListSchool.vue?vue&type=script&lang=js"
export * from "./ListSchool.vue?vue&type=script&lang=js"
import style0 from "./ListSchool.vue?vue&type=style&index=0&id=2f593087&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f593087",
  null
  
)

export default component.exports